export default {
  required: '入力してください',
  requiredSelect: '選択してください',
  basicInfo: '基本情報',
  providerType: 'プロバイダータイプ',
  providerTypeCustom: 'カスタム',
  serverType: 'サーバーAPI/SMTP',
  serverTypeAPI: 'API',
  serverTypeSMTP: 'SMTP',
  apiKey: 'API',
  apiKeyPlaceholder: 'メールサービスAPIを入力してください',
  apiSecret: 'API SECRET',
  apiSecretPlaceholder: 'メールサービスAPI Secretを入力してください',
  smtpHost: 'サーバーアドレス（SMTP）',
  smtpHostPlaceholder: 'メールサーバーアドレスを入力してください',
  smtpPort: 'ポート番号（Port）',
  smtpPortPlaceholder: 'ポート番号を入力してください（例：457または587）',
  encryption: '暗号化プロトコル',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionNone: 'なし',
  senderPassword: '送信者パスワード/認証コード',
  senderPasswordPlaceholder: '認証パスワードを入力してください',
  senderEmail: '送信者メールアドレス',
  senderEmailPlaceholder: '送信者メールアドレスを入力してください',
  senderName: '送信者ユーザー名',
  senderNamePlaceholder: '送信者ユーザー名を入力してください',
  sendTest: 'メール送信テスト',
  testRecipient: 'テスト受信者メールアドレス',
  testRecipientPlaceholder: '受信メールアドレスを入力してください',
  sendTestEmail: 'テストメール送信',
  sendTestSuccess: 'テストメール送信成功',
  sendTestFail: 'テストメール送信失敗',
  save: '設定を保存',
  saveSuccess: '保存しました',
  tabConfig: 'メール設定',
  tabSendLog: '送信ログ',
  sendLog: 'メール送信記録',
  logSendTime: '送信日時',
  logRecipient: '受信者',
  logStatus: 'ステータス',
  logTemplateName: 'テンプレート名',
};
